import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApi } from '@/utils/axios'
import { format, parseISO, parse } from 'date-fns'
import { AUTENTICACAO_ROTAS } from '@/utils/apiRoutes'

export const useMeusDadosStore = defineStore('meusDados', () => {
  const { fetch: fetchMeusDadosApi, put: updateMeusDadosApi } = useApi(AUTENTICACAO_ROTAS.PERFIL)
  const dados = ref(null)
  const loading = ref(false)
  const error = ref(null)

  async function fetchMeusDados() {
    loading.value = true
    error.value = null
    try {
      const response = await fetchMeusDadosApi()
      const user = response.data
      dados.value = {
        ...user,
        situacao: user.situacao === 1,
        freela: user.freela === 1,
        site_parceiro: user.site_parceiro === 1,
        datanascimento: user.datanascimento ? format(parseISO(user.datanascimento), 'dd/MM/yyyy') : '',
        dataadmissao: user.dataadmissao ? format(parseISO(user.dataadmissao), 'dd/MM/yyyy') : '',
        datademissao: user.datademissao ? format(parseISO(user.datademissao), 'dd/MM/yyyy') : '',
      }
      return dados.value
    } catch (err) {
      error.value = err.message || 'Erro ao carregar dados'
      throw err
    } finally {
      loading.value = false
    }
  }

  async function updateMeusDados(dadosAtualizados) {
    loading.value = true
    error.value = null
    try {
      const payload = {
        ...dadosAtualizados,
        situacao: dadosAtualizados.situacao ? 1 : 0,
        freela: dadosAtualizados.freela ? 1 : 0,
        site_parceiro: dadosAtualizados.site_parceiro ? 1 : 0,
        datanascimento: dadosAtualizados.datanascimento ? format(parse(dadosAtualizados.datanascimento, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd') : '',
        dataadmissao: dadosAtualizados.dataadmissao ? format(parse(dadosAtualizados.dataadmissao, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd') : '',
        datademissao: dadosAtualizados.datademissao ? format(parse(dadosAtualizados.datademissao, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd') : '',
      }
      if(payload.senha.length < 1) {
        delete payload.senha
        delete payload.senha_confirmation
        delete payload.senha_atual
      }
      await updateMeusDadosApi(payload)
      return { success: true }
    } catch (err) {
      // Handle validation errors (422 - Unprocessable Content)
      if (err.response && err.response.status === 422) {
        error.value = err.response.data.message || 'Erro de validação'
        return { 
          success: false,
          status: 422,
          message: err.response.data.message,
          errors: err.response.data.errors
        }
      }

      error.value = err.response?.data?.message || err.message || 'Erro ao atualizar dados'
      return { 
        success: false,
        message: error.value
      }
    } finally {
      loading.value = false
    }
  }

  return { dados, loading, error, fetchMeusDados, updateMeusDados }
})
